export const HEADER = $localize`Contact`.toUpperCase();

export const FIRST_ROW = [
  { label: $localize`Access Point Name`, size: 6 },
  { label: $localize`UAP ID`, size: 2 },
  { label: $localize`Phone No.`, size: 4 },
];

export const SECOND_ROW = [
  { label: $localize`Address`, size: 3 },
  { label: $localize`City`, size: 3 },
  { label: $localize`Province`, size: 2 },
  { label: $localize`Postal Code`, size: 2 },
  { label: $localize`Country`, size: 2 },
];

export const THIRD_ROW = [
  { label: $localize`Latitude, Longitude`, size: 3 },
  { label: $localize`Proximity Radius`, size: 9 },
];
